import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            theme: {
                colors: {
                    getAll: publicMethodUtils.extensionPublicAPI.getter('theme.getColorsConsideringGlobalVariables')
                },
                fonts: {
                    getAll: publicMethodUtils.extensionPublicAPI.getter('theme.getFontsConsideringGlobalVariables')
                }
            }
        }
    }
}
